<template>
  <div class="scoped-footer">
    {{ footer }}
  </div>
</template>
<script>
  import config from '@/tools/config'

  export default {
    computed: {
      footer() {
        return config.get('footer')
      }
    },
  }
</script>

<style lang="less" scoped>
@import '@/style/app.less';

.scoped-footer{
  width: 100%;
  padding: 15px 10px 25px 10px;
  text-align: center;
  color: @color-sub;
  position: relative;
  bottom: 0;
}
</style>